import FormErrors from "@/components/FormErrors/FormErrors";
import HmAutocompleteObject from "@/components/Autocomplete/AutocompleteObject.vue";
import uuidv4 from "uuid/v4";
import { JSConn } from "@/utilities/js-conn";
import VueScrollTo from "vue-scrollto";

export default {
  name: "workOrderTaskLineItemEditForm",
  components: {
    FormErrors,
    HmAutocompleteObject,
  },
  props: {
    taskId: String,
    lineItemId: String,
  },
  data() {
    return {
      hasLineItemErrors: false,
      lineItemErrors: [],
      lineItem: {
        id: null,
        item_date: null,
        quantity: 0,
        rate: 0,
        sort_order: 200,
        line_item_id: null,
        line_item: {},
        work_order_task_id: null,
      },
    };
  },
  computed: {
    workOrder: function() {
      return this.$store.getters.workOrder;
    },
    workOrderTaskById: function() {
      return id => this.$store.getters.workOrderTaskById(id);
    },
    workOrderTaskLineItemById: function() {
      return id => this.$store.getters.workOrderTaskLineItemById(id);
    },
    lineItemsForAutocomplete: function() {
      return this.$store.getters.lineItemsForAutocomplete;
    },
    lineItemById: function() {
      return id => this.$store.getters.lineItemById(id);
    },
  },
  methods: {
    submitLineItemForm(evt) {
      evt.preventDefault();
      // get the line item and update the rate
      const jsConn = new JSConn();

      let storeDispatch;

      if (this.lineItemId === "new") {
        storeDispatch = "createWorkOrderTaskLineItem";
      } else {
        storeDispatch = "updateWorkOrderTaskLineItem";
      }

      jsConn.formParams = this.lineItem;

      this.$store
        .dispatch(storeDispatch, jsConn)
        .then(() => {
          // move to the list of tasks
          this.$router.push({
            name: "workOrderTasks",
          });
          this.$emit("tasksChanged");
        })
        .catch(jsConn => {
          this.hasLineItemErrors = true;
          this.lineItemErrors = jsConn.error["response"]["data"];
        });
    },
    updateLineItem(evt) {
      this.lineItem.line_item = evt;
      this.lineItem.line_item_id = evt.value;
      const lnItem = this.lineItemById(this.lineItem.line_item_id);
      this.lineItem.rate = lnItem.default_rate;
    },
  },
  created() {
    if (this.lineItemId === "new") {
      this.lineItem = {
        id: uuidv4(),
        item_date: null,
        quantity: 0,
        rate: 0,
        sort_order: 200,
        line_item_id: null,
        line_item: {},
        work_order_task_id: this.taskId,
      };
    } else {
      // have to load the line item
      const taskLineItem = this.workOrderTaskLineItemById(this.lineItemId);
      const lnItem = this.lineItemById(taskLineItem.line_item_id);
      this.lineItem = {
        id: taskLineItem.id,
        item_date: taskLineItem.item_date,
        quantity: taskLineItem.quantity,
        rate: taskLineItem.rate,
        sort_order: taskLineItem.sort_order,
        line_item_id: taskLineItem.line_item_id,
        line_item: {
          value: lnItem.id,
          text: lnItem.description,
        },
        work_order_task_id: this.taskId,
      };
    }
    this.$nextTick(() => {
      VueScrollTo.scrollTo("#add-line-item-form");
    });
  },
};
